import React from 'react';

import { Menu as ChakraMenu } from '@chakra-ui/react';

export const Menu = ({ children, ...props }) => (
  <ChakraMenu autoSelect={false} placement="bottom-end" {...props}>
    {children}
  </ChakraMenu>
);
